import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { store } from '../../configureStore';

export const postEidSendLinkDetails = (data) => ({
  type: Constants.POST_EID_QUESTIONS,
  data,
});

export const postEidSendLinkDetailsApi = (questions) => {
  const questionsList = formatQues(questions?.questionAnswer || []);
  const postData = {
    cluster: 'T',
    clientId: store.getState()?.sendLinkInfo?.inspicioTokenId?.sendInspicioToken || '',
    payload: {
      pageName: 'eidQuestions',
      eidQuestions: {
        questionsList,
      },
      showConsent: 'Y',
      d2dTnCModal: 'N',
    },
    event: 'pageNavigation',
  };
  return HttpService.post(
    `/soe/digital${  apiUrls().inspicioSendMessage}`, postData
  );
};


function formatQues(questionAnswer) {
  return questionAnswer.map((ques) => ({
    questionSeqNumber: ques?.questionNumber,
    questionNumber: ques?.questionNumber,
    questionText: ques?.questionText,
    questionChoices: [{
      seqNumber: null,
      choiceSeqNumber: '1',
      questionChoiceText: ques?.choice1,
    },
    {
      seqNumber: null,
      choiceSeqNumber: '2',
      questionChoiceText: ques?.choice2,
    },
    {
      seqNumber: null,
      choiceSeqNumber: '3',
      questionChoiceText: ques?.choice3,
    },
    {
      seqNumber: null,
      choiceSeqNumber: '4',
      questionChoiceText: ques?.choice4,
    },
    {
      seqNumber: null,
      choiceSeqNumber: '5',
      questionChoiceText: ques?.choice5,
    }],
  }));
}


export const postEidAnswers = (eidData) => ({ type: Constants.POST_EID_ANSWERS, eidData });

export const postEidAnswersApi = (action) => {
  const eidData = action.eidData || [];
  const eidVerifier = eidData.map((ans) => ({ question: ans?.seqNumber, answer: ans?.choiceSeqNumber }));
  const data = {
    serviceHeader: {
      statusMsg: 'PEGA generated message',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    serviceBody: {
      serviceRequest: {
        context: {
          customerInfo: {
            processingMTN: '',
            originalCreditApprovalNumber: '',
            customerType: 'N',
          },
          cartInfo: {
            itemType: 'SUBMIT-EID-ANSWERS',
            intendType: 'NSE_5G',
            action: 'UPDATE',
            eidVerifier,
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: 'NSE_5G',
            processStep: 'EligibilityReview',
            processAction: 'submitEidAnswers',
          },
        },
      },
    },
  };
  return HttpService.post(
    `${getSecureBaseUrl()}${  apiUrls().nse5GProcessEidFlow}`, data
  );
};
